var _rect, _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUnidadeSocioeducativa = function SvgUnidadeSocioeducativa(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#ECF0FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6592 24.5866L28.1166 28.0575L24.2977 30.1791C22.265 31.3084 21.8783 34.0693 23.5226 35.7135L26.5191 38.71C27.4916 39.6825 28.9435 39.9953 30.2302 39.5096L35.1986 37.6338L38.2226 40.7523C38.2226 40.7523 38.1701 42.7262 39.9765 43.3757C41.8604 44.053 43.9206 42.3602 43.4489 40.3353C42.9379 38.1414 40.7422 38.2545 40.7422 38.2545L37.6551 35.1604L39.5047 30.3036C40.0239 28.9506 39.6555 27.4176 38.5784 26.4481L35.1989 23.4066C33.431 21.8155 30.6252 22.4132 29.6592 24.5866ZM31.5028 29.0371L32.8644 26.0057L36.2318 29.0371L34.9446 32.4509L31.5028 29.0371ZM29.0683 31.5554L32.4728 34.9413L29.0029 36.2379L25.9715 33.2157L29.0683 31.5554Z",
    fill: "#003A79"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8269 57.4929C30.2035 57.4929 23.3292 47.9728 24.3408 38.9831C24.3408 38.9831 26.8218 41.91 29.4401 41.4229C29.857 46.676 34.0226 52.6908 41.9061 52.2044C47.9376 51.8322 51.8922 46.8764 52.1662 41.7616C52.5594 34.4222 47.1124 29.8177 41.4636 29.4655C41.8373 26.4323 38.936 24.3662 38.936 24.3662C51.0907 23.4655 57.5028 32.7492 57.5028 40.9493C57.5028 49.3891 50.6941 57.4929 40.8269 57.4929Z",
    fill: "#003A79"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4527 41.1023C36.4527 41.1023 36.5401 44.5698 40.3142 45.2537C41.8649 45.5348 44.9202 44.5208 45.2764 41.2922C45.5007 39.2595 43.8811 36.8755 41.5608 36.4978L39.674 34.6808L41.036 31.2089C51.6976 32.19 51.7688 43.2262 48.2535 47.0421C43.4098 52.7381 31.9552 51.2871 31.2082 40.9916L34.7387 39.6443L36.4527 41.1023Z",
    fill: "#003A79"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUnidadeSocioeducativa, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/unidade-socioeducativa.51fef2e4.svg";
export { ForwardRef as ReactComponent };